import styled from 'styled-components';

const FlexColum = styled.div`
  display: flex;
  flex-direction: column;
`;

export default FlexColum;
